import {omit} from 'lodash';
import React, {FC} from 'react';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {RendererOf} from '../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {DropdownSeparator} from '../../../../libs/shared/ui/src/components/dropdowns/dropdownSeparator';
import {SimpleDropdown} from '../../../../libs/shared/ui/src/components/dropdowns/simpleDropdown/simpleDropdown';
import {PopoverTransferProps} from '../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {PermissionSimpleDropdownItem} from '../../common/dropdowns/permissionSimpleDropdownItem';
import {EditSidebarCopy} from './editor/copy/edit-sidebar-copy';
import {HideInSidebarCopy} from './editor/copy/hide-in-sidebar-copy';
import {WorkspaceInboxItem, WorkspaceInboxItemProps} from './workspaceInboxItem';

/*
 * Props.
 */

interface WorkspaceInboxItemContainerComponentProps extends WorkspaceInboxItemProps {
  onEditWorkspaces: () => void;
  onHideFromWorkspace: (arg: number) => void;
  onEditClick: () => void;
  canBeHidden: boolean;
  shouldHideMoreMenu: boolean;
  hasEditPermission: boolean;
  shouldShowRefinedResultsIndicator: boolean;
}

/*
 * Component.
 */

export const WorkspaceInboxItemContainerComponent: FC<WorkspaceInboxItemContainerComponentProps> = (
  props,
) => {
  // WorkspaceInboxItem doesn't need props just for WorkspaceInboxItemContainerComponent.
  const componentProps = omit(props, [
    'onEditWorkspaces',
    'onHideFromWorkspace',
    'shouldHideMoreMenu',
    'canBeHidden',
  ]);
  const onHide: () => void = () => {
    props.onHideFromWorkspace(props.inbox.id);
  };

  const renderMoreMenu = createRenderMoreMenu(props, onHide);
  return <WorkspaceInboxItem {...componentProps} renderMenu={renderMoreMenu} />;
};

/*
 * Helpers.
 */

/**
 * For now, these are the same as the helpers for
 * @see WorkspaceGenericItemContainerComponent
 * We can build an abstraction for these during the P1 Declutter project.
 */

function createRenderMoreMenu(
  props: WorkspaceInboxItemContainerComponentProps,
  onHide: () => void,
): RendererOf<PopoverTransferProps> | undefined {
  const {shouldHideMoreMenu} = props;

  if (shouldHideMoreMenu) {
    return undefined;
  }

  return (popoverProps) => renderMoreDropdown(popoverProps, props, onHide);
}

function renderMoreDropdown(
  popoverProps: PopoverTransferProps,
  props: WorkspaceInboxItemContainerComponentProps,
  onHide: () => void,
) {
  const {canBeHidden, onEditWorkspaces, onEditClick} = props;

  return (
    <SimpleDropdown {...popoverProps}>
      {props.hasEditPermission && (
        <PermissionSimpleDropdownItem onSelect={onEditClick}>
          <Trans id="teaminboxmenu-editinbox">Edit inbox</Trans>
        </PermissionSimpleDropdownItem>
      )}
      {canBeHidden && (
        <>
          <PermissionSimpleDropdownItem onSelect={onHide}>
            <HideInSidebarCopy />
          </PermissionSimpleDropdownItem>
          <DropdownSeparator />
        </>
      )}
      <PermissionSimpleDropdownItem onSelect={onEditWorkspaces}>
        <EditSidebarCopy />
      </PermissionSimpleDropdownItem>
    </SimpleDropdown>
  );
}
